import { createContext } from "react";

export const InitialPageContext = createContext();